import SearchNotFoundIconDuotone from '@/components/icons/SearchNotFoundIconDuotone';
import { t } from 'i18next';

const ApartmentsPageEmpty = () => {
	return (
		<div className='h-full flex flex-col items-center justify-center gap-2'>
			<SearchNotFoundIconDuotone className='size-8' />
			<div className='w-80 flex flex-col gap-1 text-center'>
				<h3 className='text-lg font-medium'>{t('main.apartments.components.pageEmpty.title')}</h3>
				<p className='text-sm text-popover-600'>{t('main.apartments.components.pageEmpty.description')}</p>
			</div>
		</div>
	);
};

export default ApartmentsPageEmpty;
